import { render, staticRenderFns } from "./Incapacidades.vue?vue&type=template&id=86dc6620&scoped=true"
import script from "./Incapacidades.vue?vue&type=script&lang=js"
export * from "./Incapacidades.vue?vue&type=script&lang=js"
import style0 from "./Incapacidades.vue?vue&type=style&index=0&id=86dc6620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dc6620",
  null
  
)

export default component.exports